import {
    getData,
    postData,
    deleteData
} from './Services'

export const getArtTemporadasPanel = async (artId,searchTerm, page, perPage) => {
    let queryParams = [];
    if (artId) {
        queryParams.push(`art_Id=${encodeURIComponent(artId || '')}`);
    }
    if (searchTerm) {
        queryParams.push(`temp_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';

    return await getData("/articulostemporadas", queryString);
};

export const getArtTemporadaById = async (id) => {
    const res = await getData(`/articulostemporadas/${id}`)
    return res
}

export const postArtTemporada = async (body) => {
    const res = await postData('/articulostemporadas', body)
    return res
}

export const deleteArtTemporada = async (id) => {
    const res = await deleteData(`/articulostemporadas/${id}`)
    return res
}